import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=25add1f6&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=25add1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25add1f6",
  null
  
)

export default component.exports